// import defaultV2Client from '@/plugins/axios/defaultV2Client'
import relayV2Client from '@/plugins/axios/relayV2Client'

export default {
  /**
   *
   * @param {
   * {
   *   "provider": "cafe24",
   *   "adminId": "admin",
   *   "adminPassword": "admin1234"
   * }
   * } mall
   * @returns
   */
  postMalls(mall) {
    return relayV2Client.post('/malls', mall)
  },
}
